import { Link, LinkProps } from 'react-router-dom';

export interface ButtonLinkProps extends LinkProps {
  visualType?: 'primary' | 'secondary' | 'danger';
  disabled?: boolean;
}

export default function ButtonLink({
  visualType = 'primary',
  disabled = false,
  className,
  children,
  ...rest
}: ButtonLinkProps) {
  if (!disabled) {
    return (
      <Link className={`button button-${visualType} ${className}`} {...rest}>
        {children}
      </Link>
    );
  } else {
    return <span className={`button button-disabled ${className}`}>{children}</span>;
  }
}
